import * as Types from '../../constants/actionTypes';
const initState = {
    requestDocsList: [],
    programDocTypeList: [],
    portalDocsList: []
}
export default (state = initState, action) => {
    switch (action.type) {
        /* Request Docs List */
        case Types.REQUEST_DOCS_LIST:
            return {
                ...state,
                requestDocsList: action.docList
            }
        case Types.ALL_REQUEST_DOCS_LIST:
            return {
                ...state,
                allRequestDocsList: action.allDocList
            }
        case Types.PORTAL_DOCS_LIST:
            return {
                ...state,
                portalDocsList: action.docList
            }
        case Types.PORTAL_DOCS_COUNT:
            return {
                ...state,
                portalDocsCount: action.docCount || 0
            }
        case Types.PORTAL_DOCS_ERROR:
            return {
                ...state,
                portalDocError: action.error
            }
        case Types.PORTAL_ALL_REQUEST_DOCS_LIST:
            return {
                ...state,
                allPortalRequestDocs: action.docList
            }
        case Types.PORTAL_ALL_REQUEST_DOCS_LIST_FOR_INDIVIDUAL_REPORTS:
            return {
                ...state,
                allPortalRequestDocsForIndiviualReports: action.docList
            }
        case Types.GET_INDIVIDUAL_REPORTS:
            return {
                ...state,
                getIndividualReports: { ...state.getIndividualReports, [Object.keys(action.data)]: Object.values(action.data)[0]}
            }
            // return {
            //     ...state,
            //     getIndividualReports: action.docList
            // }
        case Types.GET_INDIVIDUAL_REPORTS_COUNT:
            return {
                ...state,
                getIndividualReportsCount: { ...state.getIndividualReportsCount, [Object.keys(action.data)[0]]: action.data[Object.keys(action.data)[0]] }
            }
        case Types.FETCH_ALL_REPORTS_BY_DOC_TYPES:
            return {
                ...state,
                allReportsByDocTypeId:action.reportDocTypeList
            } 
        case Types.ADD_PROGRAM_DOC_TYPE_DATA:
                state.programDocTypeList.push(action.addedDocTypeData)
                return { ...state };    
        case Types.ON_NEW_REQUEST_DOCUMENT:
                return {
                    ...state,
                    newRequestDocument:action.payload
                }    
        case Types.PORTAL_ALL_REQUEST_DOCS_COUNT:
            return {
                ...state,
                allPortalRequestDocsCount: action.docCount
            }
        case Types.REQUEST_DOCS_ERROR:
            return {
                ...state,
                requestDocError: action.error
            }
        case Types.ADDED_REQUEST_DOCUMNET:
            state.requestDocsList.push(action.addedDoc)
            return {
                ...state
            }
        case Types.REQUEST_DOC_ITEM:
            if (action.payload) {
                const existListIndex = state.requestDocsList.findIndex((oneList) => { return oneList.docTypeId === action.payload.docTypeId })
                if (existListIndex > -1) {
                    state.requestDocsList[existListIndex] = action.payload
                }
            }
            return {
                ...state
            }

            case Types.PROGRAM_DOC_TYPE_LIST:
                return {
                    ...state,
                    programDocTypeList: action.programDocTypeList
                }

            case Types.PROGRAM_DOC_ASSET_IMAGE_TYPE:
                return {
                    ...state,
                    programAssetImageType: action.programAssetImageType
                }
        case Types.REQUEST_CIRCLE_DOCS_LIST:
            return {
                ...state,
                requestCircleDocList: action.docList
            }
        case Types.REQUEST_CIRCLE_DOCS_LIST_COUNT:
            return {
                ...state,
                requestCircleDocListCount: action.docListCount
            }
        case Types.REQUEST_DOC_DELETED:
            if (action.docEnv === 'circle') {
                const delIndex = state.requestCircleDocList && state.requestCircleDocList.findIndex(oneCircle => { return oneCircle.id === action.delId })
                if (delIndex >= 0) {
                    state.requestCircleDocList.splice(delIndex, 1)
                }
            } else {
                const delIndex = state.requestDocsList && state.requestDocsList.findIndex(nonCircle => { return nonCircle.id === action.delId })
                if (delIndex >= 0) {
                    state.requestDocsList.splice(delIndex, 1)
                }
            }
            return { ...state }
        case Types.PROGRAM_DOC_TYPE_ERROR:
            return {
                ...state,
                programDocTypeError: action.programDocTypeError
            }
        case Types.IS_SEARCH:
            return {
                ...state,
                isSearch: action.data
            }
        default:
            return state
    }
}